import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { articles } from "@/mocks/articles";

export default function DeepDive() {
  const feature = articles[3];
  const side = articles.slice(4, 7);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="DEEP DIVE"
          title="深度专题 · 把一件事看完整"
          desc="不只看热闹，还原时间线、梳理多方说法，最后留给你自己的判断。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <article className="overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7">
            <Link to={`/article/${feature.id}`} className="block cursor-pointer">
              <div className="h-60 w-full overflow-hidden md:h-72">
                <img
                  src={feature.cover}
                  alt={`${feature.title} - 深度专题配图`}
                  title={`${feature.title} - 深度专题`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </Link>
            <div className="p-6 md:p-8">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                <i className="ri-bookmark-3-line"></i>
                本期深度
              </span>
              <h3 className="mt-4 font-heading text-xl font-black leading-8 text-foreground-950 md:text-2xl">
                <Link to={`/article/${feature.id}`} className="transition-colors hover:text-primary-600">
                  {feature.title}
                </Link>
              </h3>
              <p className="mt-4 text-sm leading-7 text-foreground-600">{feature.excerpt}</p>
              <Link
                to={`/article/${feature.id}`}
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
              >
                阅读全文
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </article>

          <div className="flex flex-col gap-4 lg:col-span-5">
            {side.map((a, i) => (
              <Link
                key={a.id}
                to={`/article/${a.id}`}
                className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={a.cover}
                    alt={`${a.title} - ${a.categoryName}配图`}
                    title={`${a.title} - ${a.categoryName}`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <span className="text-xs font-medium text-secondary-700">
                    0{i + 1} · {a.categoryName}
                  </span>
                  <h3 className="mt-1 line-clamp-2 font-heading text-sm font-bold leading-6 text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                    {a.title}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}